<template>
  <div class="bg-white" v-if="showFarm">
    <h2 class="text-center p-2 bg-gray-200">
      <span class="uppercase" v-text="nameLabel"></span>
    </h2>

    <div v-if="isFirstProject && firstPriority">
      <priority
        :key="firstPriority.id"
        :data="firstPriority"
        :majoration="majoration"
        :project-rank="projectRank"
        :is-current="isCurrentPriority(firstPriority)"
        :can-be-selected="canBeSelected(firstPriority)"
        :is-upgrading="isUpgrading(firstPriority)"
        :has-lower-rank-than-previous="true"
        :i18n="i18n"
        @priority-selected="prioritySelected"
        @show-note="(k, v) => $emit('show-note', k, v)"
      />
      <details>
        <summary
          class="border-blue-200 bg-blue-100 text-blue-800 p-4 whitespace-pre-line"
          v-text="i18n.first_project_notice"
        ></summary>
        <priority
          v-for="priority in reversePriorities.slice(1)"
          :key="priority.id"
          :data="priority"
          :majoration="majoration"
          :project-rank="projectRank"
          :is-current="isCurrentPriority(priority)"
          :can-be-selected="canBeSelected(priority)"
          :is-upgrading="isUpgrading(priority)"
          :has-lower-rank-than-previous="hasLowerRankThanPrevious(priority)"
          :i18n="i18n"
          @priority-selected="prioritySelected"
          @show-note="(k, v) => $emit('show-note', k, v)"
        />
      </details>
    </div>
    <div v-else class="flex flex-col p-2">
      <transition-group name="vue-fade" tag="div">
        <priority
          v-for="priority in reversePriorities"
          :key="priority.id"
          :data="priority"
          :majoration="majoration"
          :project-rank="projectRank"
          :is-current="isCurrentPriority(priority)"
          :can-be-selected="canBeSelected(priority)"
          :is-upgrading="isUpgrading(priority)"
          :has-lower-rank-than-previous="hasLowerRankThanPrevious(priority)"
          :i18n="i18n"
          @priority-selected="prioritySelected"
          @show-note="(k, v) => $emit('show-note', k, v)"
        />
      </transition-group>
    </div>
  </div>
</template>

<script>
import Priority from "./Priority";

export default {
  props: [
    "items",
    "name",
    "majoration",
    "projectPriorities",
    "currentPriority",
    "canChangePriority",
    "upgradingPriority",
    "projectRank",
    "i18n",
    "isFirstProject",
  ],
  components: { Priority },
  data() {
    return {
      priorities: [],
    };
  },
  methods: {
    prioritySelected(priority) {
      return this.$emit("priority-selected", priority);
    },

    isCurrentPriority(priority) {
      if (this.currentPriority === null) return false;

      return priority.id === this.currentPriority.id;
    },

    hasLowerRankThanPrevious(priority) {
      let previousRank = 0;
      for (let i = 0; i < this.reversePriorities.length; i++) {
        const prio = this.reversePriorities[i];
        if (prio.id == priority.id) {
          return previousRank == 0 || prio.available_rank < previousRank;
        }
        previousRank = prio.available_rank;
      }
      return true;
    },

    isUpgrading(priority) {
      if (!this.projectPriorities.project) return false;

      return (
        this.upgradingPriority &&
        !this.isCurrentPriority(priority) &&
        priority.id === this.projectPriorities.project.id &&
        this.projectPriorities.project.id !== this.projectPriorities.qstatus.id
      );
    },

    // Check if a priority can be selected
    canBeSelected(priority) {
      if (this.upgradingPriority) {
        return false;
      }

      return priority.compatible && !this.isCurrentPriority(priority);
    },
  },
  computed: {
    reversePriorities() {
      return this.priorities.slice().reverse();
    },
    firstPriority() {
      return this.reversePriorities[0];
    },

    nameLabel() {
      if (this.name === "power") {
        return "CPU";
      }

      return this.name;
    },

    showFarm() {
      if (this.upgradingPriority) {
        return this.currentPriority.farm === this.name;
      }

      return true;
    },
  },
  mounted() {
    this.priorities = Object.keys(this.items).map((key) => {
      return this.items[key];
    });
  },
};
</script>
